import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { AiQuickPromptsQuery } from "lib/generated/app-service-gql/graphql";
import { AiQuickPromptChatType } from "lib/types/graphQLEnums";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const aiQuickPromptsQuery = graphql(`
  query aiQuickPrompts($input: AiQuickPromptsRequest!) {
    aiQuickPrompts(input: $input) {
      prompts {
        id
        scope
        name
        prompt
      }
    }
  }
`);

export type AiQuickPrompt = AiQuickPromptsQuery["aiQuickPrompts"]["prompts"][number];

export const aiQuickPromptsQueryKey = (chatType: AiQuickPromptChatType) => [
  "aiQuickPrompts",
  chatType,
];

// The current team's quick prompts for an AI chat, or the chat's defaults until the team changes them
export function useAiQuickPrompts(
  chatType: AiQuickPromptChatType,
  options?: UseQueryOptions<AiQuickPromptsQuery, unknown, AiQuickPromptsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    aiQuickPromptsQueryKey(chatType),
    aiQuickPromptsQuery,
    [{ input: { chatType } }],
    { ...REACT_QUERY_OPTIONS_NEVER_REFETCH, ...options },
  );

  return { data: data?.aiQuickPrompts, ...rest };
}
